import { Modal } from '@Calix-Commerce/design-system';
import styled from '@emotion/styled';

export const ModalStyled = styled(Modal)`
  min-height: 620px;
`;

export const ModalContentStyled = styled.div`
  min-height: 380px;
`;
